import App from '@/models/App'
import ShipUser from './ShipUser'

export default class ShipLaborPrivilege extends App {
    static get entity() {
        return 'ShipLaborPrivileges'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static getById(id) {
        return this.query().whereId(id).first()
    }
    static findByUserId(userId) {
        return this.query()
            .withAllRecursive()
            .get()
            .find(
                (privilege) =>
                    privilege.shipUser && privilege.shipUser.userId === userId
            )
    }
    static fields() {
        return {
            id: this.attr(''),
            sailor: this.attr(''),
            record: this.attr(''),
            daily: this.attr(''),
            stamp: this.attr(''),
            attend: this.attr(''),
            dashboard: this.attr(''),
            master: this.attr(''),
            shipUser: this.hasOne(ShipUser, 'laborPrivilegeId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId) {
                return this.get(`${shipId}/labor/privileges`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            update(shipId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/labor/privileges`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, privilegeId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipId}/labor/privileges/${privilegeId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
